module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.items.length > 0) ? _c('div', {
    staticClass: "container__card order-card",
    attrs: {
      "id": "card"
    }
  }, [_c('div', {
    staticClass: "wrapper-position"
  }, [(_vm.brandLogo) ? _c('div', {
    staticClass: "brand-logo",
    class: _vm.logoPosition,
    attrs: {
      "id": "brand-logo"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.brandLogo
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title left-padding",
    style: (_vm.themeColor)
  }, [_vm._v("Your Order")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "body-content",
    class: {
      'multiple-line-items': _vm.hasMoreItems
    }
  }, [(!_vm.hasMoreItems) ? _c('line-item-single', {
    attrs: {
      "item": _vm.firstItem
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasMoreItems) ? [_vm._l((_vm.itemsToShow), function(item) {
    return _c('line-item-multiple', {
      attrs: {
        "item": item
      },
      on: {
        "remove": function($event) {
          _vm.removeItem(item)
        }
      }
    })
  }), _vm._v(" "), (!_vm.showAll && _vm.remainingItems > 0) ? _c('div', {
    staticClass: "load-more-items show",
    on: {
      "click": function($event) {
        _vm.showAll = true
      }
    }
  }, [_vm._v("\n          + " + _vm._s(_vm.remainingItems) + " more items\n        ")]) : _vm._e()] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "total"
  }, [(_vm.hasMoreItems) ? _c('div', {
    staticClass: "total-footer clearfix"
  }, [_c('p', {
    staticClass: "left",
    attrs: {
      "id": "tax-text"
    }
  }, [_vm._v("Your bill amount. Taxes extra")]), _vm._v(" "), _c('p', {
    staticClass: "right total-bill show"
  }, [_vm._v("\n          " + _vm._s(_vm.totalAmount) + "\n        ")])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "continue",
    style: (_vm.backgroundColor),
    on: {
      "click": function($event) {
        _vm.showNext()
      }
    }
  }, [_vm._v("Looks good, continue →")])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-69487974!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CartSummary.vue
// module id = 83
// module chunks = 0